import { notification } from 'antd';
import LoadingProcedure from 'components/loading-procedure';
import ModalWarning from 'components/modal-warning';
import Context from 'context/appContext';
import { useContext, useEffect, useState } from 'react';
import { getBodyCalculator, getNotificationStyle, setFieldsValue } from 'utils/utils';
import Cards from '../../../assets/images/hogar-vivienda.png'

// @styles 
import '../cards-coverages/styles.scss'

export default function CardsSwitch({ info, form, current, index }) {
    const [defaultClass, setDefaultClass] = useState('active-btn-right');
    const [alert, setAlert] = useState(false);
    const [api, contextHolder] = notification.useNotification();
    const [loadingComponent, setLoadingComponent] = useState(false);
    const { dataForm: { formResponses }, isActiveAditionals, customRequest, priceToShow, sidebarData, setIsActiveAditionals, setPriceToShow, formStatus: { steps, currentStep, currentQuestion } } = useContext(Context);
    const messageAdd = "Tu descuento ha sido agregado con éxito";
    const messageRemove = "Tu descuento ha sido removido con éxito";

    useEffect(async() => {
        getDiscountHook();
        !priceToShow && sidebarData && (await serviceCalculator(null));
    }, [])

    const getDiscountHook = () => {
        const keys = ['hasFireAlarm', 'hasSecurityAlarm'];
        let copyAdd = JSON.parse(JSON.stringify(isActiveAditionals));
        keys.forEach(key => {
            const discount = formResponses.find(x => x.key === key);
            if (discount) {
                copyAdd = { ...copyAdd, [key]: discount.value }
            }
        })
        setIsActiveAditionals(copyAdd);
    }

    const onClickCover = async (index, active, discount) => {
        // setFieldsValue(index, active, null, formResponses, form, 'discount', Number(discount));
        const indexF = formResponses.findIndex(x => x.key === index);
        if (indexF !== -1) {
            formResponses[indexF].discount = active ? Number(discount) : 0;
            formResponses[indexF].value = active;
        } else {
            formResponses.push({ key: index, value: active, discount: discount })
        }
        setIsActiveAditionals({ ...isActiveAditionals, [index]: active });
        setDefaultClass('active-btn-right');
        await serviceCalculator();
        openNotification(active);
    };

    const openNotification = (choosed, messageChange) => {
        if (choosed) {
            openNotificationWithIcon("success", messageChange || messageAdd);
        } else {
            openNotificationWithIcon("error", messageRemove);
        }
    };

    const openNotificationWithIcon = (type, description) => {
        api[type]({
            message: ``,
            description,
            style: getNotificationStyle(type),
        });
    };

    const serviceCalculator = async (newFormResponse) => {
        setLoadingComponent(true);
        const valPrimary = steps[currentStep] && steps[currentStep].questions[currentQuestion] && steps[currentStep].questions[currentQuestion].primary;
        const options = valPrimary && valPrimary.opciones_servicio_segundo_plano
            ? valPrimary.opciones_servicio_segundo_plano
            : '';
        const opciones_servicio = options && JSON.parse(options);
        const body = getBodyCalculator(opciones_servicio.body, newFormResponse || formResponses, form);
        await customRequest(opciones_servicio.url, opciones_servicio.header, opciones_servicio.method, body).then((res) => {
            if (res && res.errors) {
                const errors = res && res.errors
                setAlert({ active: true, message: errors.description, fields: errors.fields })
            }
            res && res.data && res.data.totalPremium && setPriceToShow(res.data.totalPremium);
            return false
        })
        setLoadingComponent(false);
    }

    return (
        <>
            {contextHolder}
            {alert && alert.active && <ModalWarning info={{ visible: true, type: 'error', message: alert && alert.message, fields: alert.fields }} callBack={() => setAlert({ active: false })} />}
            {loadingComponent && (<LoadingProcedure message={'Aplicando descuento'} />)}
            <div className='coverages-economy'>
                <div className='coverages-economy__content'>
                    <div className='coverages-economy__content-additionalcards'>
                        {info && info.components && info.components.map(item => {
                            const index = item && item.key;
                            const discount = item && item.tooltip;
                            return <div className='coverages-economy__content-additionalcards__item'>
                                <img className='coverages-economy__content-additionalcards__item-img' src={item.properties && item.properties.img ? item.properties.img : Cards} alt={item.label} />
                                <div className='coverages-economy__content-additionalcards__item-text'>
                                    <strong>{item.label}</strong>
                                    <p>
                                        {item.description}
                                    </p>
                                </div>
                                <div className='smallswitch__container' id={index}>
                                    <div className='smallswitch__container__buttons' id={index}>
                                        <button className={`smallswitch__container__buttons-btn ${!isActiveAditionals[index] ? 'active-btn-left' : ''}`}
                                            disabled={!isActiveAditionals[index]}

                                            onClick={() => onClickCover(index, false, discount)}>
                                            <span>No</span>
                                        </button>
                                        <button className={`smallswitch__container__buttons-btn ${isActiveAditionals[index] && defaultClass}`}
                                            disabled={isActiveAditionals[index]}
                                            onClick={() => onClickCover(index, true, discount)}>
                                            <span>Si</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        })}
                    </div>
                </div>
            </div>
        </>
    )
}